import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { notification } from "antd";

import Table, { HeadsType, RowType } from "../../Shared/CustomTable";
import moment from "moment-timezone";
import {
  fixDecimals,
  getMetricLabelFromHeaderLiveMetrics,
  getMetricValue,
  msToTime,
  prePathViewPage,
} from "../../../helpers/helpers";
import {
  CONDENSED_VIEW_HEADER_KEYS,
  GAME,
  LIVE_PRACTICE,
  PAST_PRACTICE,
  RELATIVE_METRICS,
  FILTER_KEYS,
  SHOW_DISTANCE_GRAPHS,
  VIEW_LIVE,
  EMPTY_ARRAY,
  SPEED_HEADERS,
  DISTANCES_HEADERS,
  COUNTS_HEADERS,
  ACCEL_COUNTS,
  DECEL_COUNTS,
  SPEED_ROWS,
  DISTANCES_ROWS,
  COUNTS_ROWS,
  ACCEL_COUNTS_ROWS,
  DECEL_COUNTS_ROWS,
  SPEED_ROWS_PERCENTAGES,
  DISTANCES_ROWS_PERCENTEGES,
  COUNTS_ROWS_PERCENTAGES,
  CONDENSED_VIEW_HEADER_COUNTS,
  CUSTOM_ZONE_METRICS,
  CUSTOM_ZONE_LIVE_HEADERS,
  CUSTOM_ZONE_LIVE_ROWS,
  CUSTOM_ZONE_LIVE_ROWS_PERCENTAGES,
  LOAD_METRICS,
  LOAD_METRICS_ROWS,
} from "../../../config/constants";
import PlayerBallMetricsModal from "../Modal";
import DistanceGraphOnRow from "./DistanceGraphOnRow";
import MoreButton from "./MoreButton";
import { useRouter } from "../../../helpers/customHooks";
import {
  useDataEventsState,
  useFiltersState,
  usePlayersDispatch,
  usePlayersState,
} from "../../../store/hooks";
import { CondensedExpanded, PerformanceRoutes, PlayerNotesType } from "./types";
import excludeLogo from "../../../assets/close-thick-01.svg";
import notExcludeLogo from "../../../assets/close-thick-gray.svg";
import { ReactComponent as TextBoxIcon } from "../../../assets/text-box-edit.svg";
import CondensedMobile from "./CondensedMobile";
import PlayerNoteModal from "../PlayerNoteModal";
import LiveSpeedsModal from "../LiveSpeedsModal";
import { isIn } from "helpers";
import { useDispatch } from "react-redux";
import { saveAlerts } from "store/actions";
import { useCustomEventsState } from "store/hooks/customEvents";
import { Alert } from "components/Alerting/types";

export default ({
  shownHighlights,
  hidden,
  hasUpdate,
  playerNotes,
  targetedReprocess,
  targetedPlayers,
  updateTargetedPlayers,
  customAlerts,
  hitedAlerts,
  updateSpeeds,
  updateSelectedPlayers,
  selectedPlayers,
  showUpdateSpeeds,
  setShowUpdateSpeeds,
  setSelectedPlayers,
  setUpdateSpeeds,
}: CondensedExpanded) => {
  const { dataEvent: data } = useDataEventsState();
  const {
    history,
    pathname,
    params,
    eventType,
    specificScope,
    viewPracticeGamePageScope,
  } = useRouter<PerformanceRoutes>();
  const {
    [FILTER_KEYS.SHOW_DISTANCE_GRAPHS]: showDistanceGraphs,
    [FILTER_KEYS.ZONE_TYPE]: zoneType,
    [FILTER_KEYS.DATE_RANGE]: dateRange,
    [FILTER_KEYS.PERIODS]: periods,
    [FILTER_KEYS.VIEW_LIVE]: viewData = VIEW_LIVE.types[0],
    [FILTER_KEYS.CUSTOM_LIVE_TABLE]: viewCustom = EMPTY_ARRAY,
  } = useFiltersState(
    viewPracticeGamePageScope,
    FILTER_KEYS.SHOW_DISTANCE_GRAPHS,
    FILTER_KEYS.ZONE_TYPE,
    FILTER_KEYS.DATE_RANGE,
    FILTER_KEYS.PERIODS,
    FILTER_KEYS.VIEW_LIVE,
    FILTER_KEYS.CUSTOM_LIVE_TABLE
  );
  const { excludePlayers } = usePlayersDispatch();
  const dispatch = useDispatch();
  const { excludedPlayers } = usePlayersState();
  const { speedAlerts } = useCustomEventsState();
  const isLive = data.meta.type === LIVE_PRACTICE;
  const gameId = data.meta.gameId;
  const teamId = data.meta.homeTeam.teamId;
  const [excluded, setExcluded] = useState(
    excludedPlayers && excludedPlayers[gameId] ? excludedPlayers[gameId] : []
  );
  const isMobile = window.matchMedia(
    "only screen and (max-width: 900px)"
  ).matches;
  const customTotalWidth = 896;
  const [showPlayerNote, setShowPlayerNote] = useState(false);
  const [playerId, setPlayerId] = useState("");
  const [playerTeamId, setPlayerTeamId] = useState("");
  const [playerName, setPlayerName] = useState("");
  const [playerNote, setPlayerNote] = useState<string | undefined>("");
  const [noteType, setNoteType] = useState<string | undefined>("");
  const [alertKeys, setAlertKeys] = useState<string[]>([]);
  const [alertArray, setAlertArray] = useState<any[]>(hitedAlerts || []);

  let maxDistance = 0;
  if (data && data.data && data.data.players) {
    data.data.players.forEach((player) => {
      maxDistance = Math.max(
        maxDistance,
        +fixDecimals(player.metrics.walkYds, 0) +
          +fixDecimals(player.metrics.jogYds, 0) +
          +fixDecimals(player.metrics.runYds, 0) +
          +fixDecimals(player.metrics.sprintYds, 0) +
          +fixDecimals(player.metrics.maxSprintYds, 0)
      );
    });
  }

  const notificationPlayerAlert = (
    notificationKey: string,
    name: string,
    time: number,
    metric: string,
    metricValue: string
  ) => {
    const args = {
      key: notificationKey,
      message: "Player Alert",
      description: `${moment
        .tz(time, moment.tz.guess())
        .format("hh:mm:ss")} - ${name} has hit ${metricValue} ${metric}.`,
      duration: 5,
      icon: (
        <span
          className="mdi mdi-alert-box-outline"
          style={{ color: "#0378bf", fontSize: "30px" }}
        />
      ),
    };
    notification.open(args);
  };

  const excludePlayer = (id: string) => {
    const index = excluded.indexOf(id);
    if (index > -1) {
      excluded.splice(index, 1);
      setExcluded([...excluded]);
    } else {
      setExcluded([...excluded, id]);
    }
  };
  useEffect(() => {
    excludePlayers(gameId, excluded);
  }, [JSON.stringify(excluded)]);

  useEffect(() => {
    if (hitedAlerts) setAlertArray(hitedAlerts);
  }, [hitedAlerts]);

  const triggerAlert = (
    key: string,
    playerName: string,
    metric: string,
    metricValue: string,
    hasTime?: number
  ) => {
    const now = new Date().getTime();
    const indexAlert = hitedAlerts
      ? hitedAlerts.findIndex((obj) => obj.key === key)
      : -1;
    const alert = {
      key: key,
      time: hasTime ? hasTime : now,
      metric,
      name: playerName,
      metricValue,
    };
    if (!hitedAlerts || indexAlert === -1) {
      alertArray.push(alert);
      dispatch(saveAlerts(alertArray, gameId));
      notificationPlayerAlert(
        key,
        playerName,
        hasTime ? hasTime : now,
        metric,
        metricValue
      );
    }
  };

  const [isCounts, setIsCounts] = useState(false);
  const [sortByPercentageSpeed, setSortByPercentageSpeed] = useState(false);
  const [sortByPercentageDist, setSortByPercentageDist] = useState(false);
  const [sortByPercentageCustom, setSortByPercentageCustom] = useState(false);
  const changeHeadersCount = () => {
    if (!isCounts) {
      setIsCounts(true);
    } else {
      setIsCounts(false);
    }
  };

  const changeSortValue = (speed:boolean, distances: boolean, custom:boolean) =>{
    if(speed){
      setSortByPercentageSpeed(!sortByPercentageSpeed);
    }
    if(distances){
      setSortByPercentageDist(!sortByPercentageDist);
    }
    if(custom){
      setSortByPercentageCustom(!sortByPercentageCustom);
    }
  }
  const playerNotesColors: PlayerNotesType[] = [];
  if (playerNotes && playerNotes.length !== 0) {
    playerNotes.forEach((note) => {
      playerNotesColors.push({
        playerId: note.playerId,
        type: note.type
          ? note.type === "Modified"
            ? "M"
            : note.type === "Rehab"
            ? "R"
            : note.type === "Partial/Limited"
            ? "L"
            : note.type === "None"
            ? "-"
            : note.type === "Full"
            ? "F"
            : "F"
          : "F",
        color:
          note.type === "Modified"
            ? "yellow"
            : note.type === "Rehab"
            ? "red"
            : note.type === "Partial/Limited"
            ? "orange"
            : note.type === "None"
            ? "grey"
            : note.type === "Full"
            ? "green"
            : "green",
        note: note.note,
      });
    });
  }
  const CUSTOM_HEADERS: string[] = [];
  const CUSTOM_ROWS: string[] = [];
  const CUSTOM_ROWS_PERCENTAGES: string[] = [];
  if (viewData.value === VIEW_LIVE.types[1].value) {
    viewCustom.forEach((data) => {
      if (data) {
        if (data.name.split(".")[0] === "0") {
          CUSTOM_HEADERS.push(SPEED_HEADERS[data.name.split(".")[1]]);
          CUSTOM_ROWS.push(SPEED_ROWS[data.name.split(".")[1]]);
          CUSTOM_ROWS_PERCENTAGES.push(
            SPEED_ROWS_PERCENTAGES[data.name.split(".")[1]]
              ? SPEED_ROWS_PERCENTAGES[data.name.split(".")[1]]
              : ""
          );
        }
        if (data.name.split(".")[0] === "1") {
          CUSTOM_HEADERS.push(DISTANCES_HEADERS[data.name.split(".")[1]]);
          CUSTOM_ROWS.push(DISTANCES_ROWS[data.name.split(".")[1]]);
          CUSTOM_ROWS_PERCENTAGES.push(
            DISTANCES_ROWS_PERCENTEGES[data.name.split(".")[1]]
              ? DISTANCES_ROWS_PERCENTEGES[data.name.split(".")[1]]
              : ""
          );
        }
        if (data.name.split(".")[0] === "2") {
          CUSTOM_HEADERS.push(COUNTS_HEADERS[data.name.split(".")[1]]);
          CUSTOM_ROWS.push(COUNTS_ROWS[data.name.split(".")[1]]);
          CUSTOM_ROWS_PERCENTAGES.push(
            COUNTS_ROWS_PERCENTAGES[data.name.split(".")[1]]
          );
        }
        if (data.name.split(".")[0] === "3") {
          CUSTOM_HEADERS.push(ACCEL_COUNTS[data.name.split(".")[1]]);
          CUSTOM_ROWS.push(ACCEL_COUNTS_ROWS[data.name.split(".")[1]]);
          CUSTOM_ROWS_PERCENTAGES.push("");
        }
        if (data.name.split(".")[0] === "4") {
          CUSTOM_HEADERS.push(DECEL_COUNTS[data.name.split(".")[1]]);
          CUSTOM_ROWS.push(DECEL_COUNTS_ROWS[data.name.split(".")[1]]);
          CUSTOM_ROWS_PERCENTAGES.push("");
        }
        if (data.name.split(".")[0] === "5") {
          CUSTOM_HEADERS.push(
            CUSTOM_ZONE_LIVE_HEADERS[data.name.split(".")[1]]
          );
          CUSTOM_ROWS.push(CUSTOM_ZONE_LIVE_ROWS[data.name.split(".")[1]]);
          CUSTOM_ROWS_PERCENTAGES.push(
            CUSTOM_ZONE_LIVE_ROWS_PERCENTAGES[data.name.split(".")[1]]
          );
        }
        if (data.name.split(".")[0] === "6") {
          CUSTOM_HEADERS.push(LOAD_METRICS[data.name.split(".")[1]]);
          CUSTOM_ROWS.push(LOAD_METRICS_ROWS[data.name.split(".")[1]]);
          CUSTOM_ROWS_PERCENTAGES.push("");
        }
      }
    });
    if (CUSTOM_HEADERS.length <= 11) {
      CUSTOM_HEADERS.push(" ");
    }
    if (CUSTOM_ROWS.length <= 11) {
      CUSTOM_ROWS.push(" ");
    }
  }

  const thresholdSelected = dateRange?.threshold
    ? dateRange?.threshold
    : 1000000;
  const relative = zoneType && zoneType === "Player" ? 1 : 0;
  const customZone = zoneType && zoneType === "Custom";
  const headers: HeadsType<string, JSX.Element> = [
    ...(targetedReprocess || updateSpeeds
      ? [
          {
            print: () => (
              <i
                className="mdi mdi-checkbox-marked-outline"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              />
            ),
            style: { width: "33px" },
            isColumnFixedY: true,
          },
        ]
      : [
          {
            class: "flag",
            isPinFlagCell: true,
            isSelectable: true,
            style: { width: "33px" },
            isColumnFixedY: true,
          },
        ]),
    {
      content: "EX.",
      isExcludeCell: true,
      style: { width: "33px", textAlign: "right" },
      isOrderly: true,
      isColumnFixedY: true,
    },
    {
      content: "PLAYER",
      style: { width: "146px", textAlign: "left" },
      isOrderly: true,
      isColumnFixedY: true,
    },
    {
      style: { width: "60px" },
      content: "STATUS",
      isOrderly: true,
      isColumnFixedY: true,
    },
    {
      content: "NO.",
      style: { width: "40px" },
      isOrderly: true,
      isColumnFixedY: true,
    },
    {
      class: "t-ll",
      content: "POS.",
      style: { width: "64px" },
      isOrderly: true,
      isColumnFixedY: true,
    },
    ...(viewData.value === VIEW_LIVE.types[0].value
      ? [
          {
            content: "TARGET SPEED",
            style: { width: "60px" },
            isOrderly: true,
          },
          {
            content: "MAX SPEED",
            metric: CONDENSED_VIEW_HEADER_KEYS[5],
            style: { width: "85px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
            print:(content: string)=>(<label className="max-speed-label">{content}</label>)
          },
          {
            content: "MAX SUST. SPEED",
            metric: CONDENSED_VIEW_HEADER_KEYS[6],
            style: { width: "85px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "TIME SINCE X% OF MAX",
            class: "t-ll",
            style: { width: "70px" },
            isOrderly: true,
          },
          {
            content: "TOTAL DIST",
            metric: CONDENSED_VIEW_HEADER_KEYS[8],
            style: { width: "81px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "HARD EFF. DIST.",
            metric: getMetricValue(
              false,
              relative,
              customZone,
              "",
              CONDENSED_VIEW_HEADER_KEYS[9]
            ),
            style: { width: "81px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "WALK",
            metric: getMetricValue(
              isCounts,
              relative,
              customZone,
              CONDENSED_VIEW_HEADER_COUNTS[0],
              CONDENSED_VIEW_HEADER_KEYS[10]
            ),
            style: { width: "71px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "JOG",
            metric: getMetricValue(
              isCounts,
              relative,
              customZone,
              CONDENSED_VIEW_HEADER_COUNTS[1],
              CONDENSED_VIEW_HEADER_KEYS[11]
            ),
            style: { width: "71px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "RUN",
            metric: getMetricValue(
              isCounts,
              relative,
              customZone,
              CONDENSED_VIEW_HEADER_COUNTS[2],
              CONDENSED_VIEW_HEADER_KEYS[12]
            ),
            style: { width: "71px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "SPRINT",
            metric: getMetricValue(
              isCounts,
              relative,
              customZone,
              CONDENSED_VIEW_HEADER_COUNTS[3],
              CONDENSED_VIEW_HEADER_KEYS[13]
            ),
            style: { width: "71px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "MAX SPRINT",
            metric: getMetricValue(
              isCounts,
              relative,
              customZone,
              CONDENSED_VIEW_HEADER_COUNTS[4],
              CONDENSED_VIEW_HEADER_KEYS[14]
            ),
            style: { width: "71px" },
            class: "t-ll",
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "LOW",
            metric: CONDENSED_VIEW_HEADER_KEYS[15],
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "MED.",
            metric: CONDENSED_VIEW_HEADER_KEYS[16],
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "HIGH",
            metric: CONDENSED_VIEW_HEADER_KEYS[17],
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "MAX STND ACCEL",
            metric: CONDENSED_VIEW_HEADER_KEYS[18],
            class: "t-ll",
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "LOW",
            metric: CONDENSED_VIEW_HEADER_KEYS[19],
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "MED.",
            metric: CONDENSED_VIEW_HEADER_KEYS[20],
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "HIGH",
            metric: CONDENSED_VIEW_HEADER_KEYS[21],
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "MAX STND DECEL",
            metric: CONDENSED_VIEW_HEADER_KEYS[22],
            class: "t-ll",
            style: { width: "50px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "CUMULATIVE LOAD",
            metric: CONDENSED_VIEW_HEADER_KEYS[23],
            style: { width: "73px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
          {
            content: "LOAD BIAS",
            metric: CONDENSED_VIEW_HEADER_KEYS[24],

            style: { width: "60px" },
            isOrderly: true,
            hoverButton:
              eventType !== GAME &&
              !isLive &&
              ((metric: string) => (
                <MoreButton key={"more-c-" + String(metric)} metric={metric} />
              )),
          },
        ]
      : viewData.value === VIEW_LIVE.types[1].value
      ? [
          ...CUSTOM_HEADERS.map((content, index) => {
            return {
              content: content,
              style:
                CUSTOM_HEADERS.length <= 11
                  ? index + 1 === CUSTOM_HEADERS.length
                    ? {
                        width: `${
                          customTotalWidth - (CUSTOM_HEADERS.length - 1) * 85
                        }px`,
                      }
                    : { width: "85px" }
                  : {},
              metric: CUSTOM_ROWS[index],
              isOrderly: content !== " " ? true : false,
              hoverButton:
                content !== " " &&
                !content.includes("TARGET SPEED") &&
                !content.includes("X%") &&
                !isLive &&
                ((metric: string) => (
                  <MoreButton
                    key={"more-e-" + String(metric)}
                    metric={metric}
                  />
                )),
            };
          }),
        ]
      : []),
  ];
  const prePath = prePathViewPage(pathname);
  const rows: RowType[] = [];
  if (data && data.data && data.data.players) {
    data.data.players.forEach((player) => {
      if (
        customAlerts &&
        customAlerts[teamId] &&
        data.meta.type === LIVE_PRACTICE
      ) {
        const playerAlerts = customAlerts[teamId].players.find(
          (x: any) => x.id === player.id
        )?.alerts;
        if (playerAlerts) {
          playerAlerts.forEach((alert: Alert) => {
            if (
              alert.active &&
              player.metrics &&
              player.metrics[alert.type] !== undefined &&
              (alert.type === "maxSustDecel"
                ? +player.metrics[alert.type] <= +alert.value
                : +player.metrics[alert.type] >= +alert.value)
            ) {
              const metric = getMetricLabelFromHeaderLiveMetrics(alert.type);
              if (!metric.includes("speed")) {
                const key = metric + player.id;
                if (!alertKeys.includes(key)) {
                  triggerAlert(key, player.name, metric, alert.value);
                  alertKeys.push(key);
                }
              }
            }
          });
        }
        if (
          data.alerts &&
          data.alerts.speedMPH &&
          data.alerts.speedMPH.length > 0
        ) {
          if (
            speedAlerts.customSpeedAlerts.find(
              (obj: any) => obj.nid === player.id
            ) &&
            speedAlerts.customSpeedAlerts.find(
              (obj: any) => obj.nid === player.id
            ).target
          ) {
            const index = data.alerts.speedMPH.findIndex(
              (obj: any) => Object.keys(obj)[0] === player.id
            );
            const target = speedAlerts.customSpeedAlerts.find(
              (obj: any) => obj.nid === player.id
            ).target;
            data.alerts.speedMPH[index][player.id].forEach((time: number) => {
              const timeStamp = time;
              const key = "speedMPH" + player.id + time;

              if (!alertKeys.includes(key)) {
                triggerAlert(key, player.name, "MPH", target, timeStamp);
                alertKeys.push(key);
              }
            });
          }
        }
      }
      const dataDistanceGraph = [
        JSON.stringify(showDistanceGraphs) ===
        JSON.stringify(SHOW_DISTANCE_GRAPHS.types[0])
          ? fixDecimals(
              player.metrics[
                relative ? RELATIVE_METRICS["walkYds"] : "walkYds"
              ],
              0
            )
          : 0,
        JSON.stringify(showDistanceGraphs) ===
        JSON.stringify(SHOW_DISTANCE_GRAPHS.types[0])
          ? fixDecimals(
              player.metrics[relative ? RELATIVE_METRICS["jogYds"] : "jogYds"],
              0
            )
          : 0,
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[0]) ||
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[1]) ||
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[2])
          ? fixDecimals(
              player.metrics[relative ? RELATIVE_METRICS["runYds"] : "runYds"],
              0
            )
          : 0,
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[0]) ||
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[1]) ||
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[3])
          ? fixDecimals(
              player.metrics[
                relative ? RELATIVE_METRICS["sprintYds"] : "sprintYds"
              ],
              0
            )
          : 0,
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[0]) ||
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[1]) ||
        JSON.stringify(showDistanceGraphs) ===
          JSON.stringify(SHOW_DISTANCE_GRAPHS.types[4])
          ? fixDecimals(
              player.metrics[
                relative ? RELATIVE_METRICS["maxSprintYds"] : "maxSprintYds"
              ],
              0
            )
          : 0,
      ];

      rows.push({
        columns: [
          ...(targetedReprocess || updateSpeeds
            ? [
                {
                  isPinFlagCell: false,
                  print: () => {
                    const handleChange = () => {
                      if (targetedReprocess && updateTargetedPlayers) {
                        updateTargetedPlayers([player.id]);
                      }

                      if (updateSpeeds && updateSelectedPlayers) {
                        updateSelectedPlayers([
                          {
                            name: player.name,
                            id: player.id,
                            max: "",
                            maxS: "",
                          },
                        ]);
                      }
                    };
                    return (
                      <>
                        <input
                          type="checkbox"
                          id="cb1"
                          checked={
                            targetedReprocess
                              ? targetedPlayers
                                ? isIn(targetedPlayers, player.id)
                                : false
                              : updateSpeeds
                              ? selectedPlayers
                                ? selectedPlayers?.some(
                                    (p) => p.id === player.id
                                  )
                                : false
                              : false
                          }
                          onChange={handleChange}
                        />
                      </>
                    );
                  },
                  style: { width: "33px" },
                },
              ]
            : [
                {
                  class: "flag",
                  isPinFlagCell: true,
                  id: "condensed-flag-" + player.id,
                },
              ]),

          {
            content:
              excluded && excluded[excluded.indexOf(player.id)] === player.id
                ? 1
                : 0,
            isExcludeCell:
              excluded && excluded[excluded.indexOf(player.id)] === player.id
                ? true
                : false,
            id: "exclude-player-" + player.id,
            print: (content) =>
              excluded &&
              excluded[excluded.indexOf(player.id)] === player.id ? (
                <img
                  src={excludeLogo}
                  width="17px"
                  id={"mdi mdi-close-icon" + player.id}
                  onClick={() => excludePlayer(player.id)}
                />
              ) : (
                <img
                  src={notExcludeLogo}
                  width="17px"
                  id={"mdi mdi-close-icon" + player.id}
                  onClick={() => excludePlayer(player.id)}
                />
              ),
            order: (contentA, contentB) => contentA - contentB,
          },
          {
            // class: 'player-img',
            style: {
              // backgroundImage: `url(https://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/${player.esbId}.png)`,
              fontWeight: "bold",
            },
            content: player.name,
            print: (content) => (
              <Link to={{ pathname: prePath + "/modal/" + player.id }}>
                <div
                  style={{
                    width: "126px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {content}
                </div>
              </Link>
            ),
            order: (contentA, contentB) => {
              if (contentA.split(" ").length < 2) {
                return contentA.localeCompare(contentB);
              }
              const lastNameA = contentA.split(" ")[1];
              const lastNameB = contentB.split(" ")[1];
              return lastNameA.localeCompare(lastNameB);
            },
          },
          {
            content: {
              type:
                playerNotesColors &&
                playerNotesColors.find(
                  (e: PlayerNotesType) => e.playerId === player.id
                )?.type
                  ? playerNotesColors.find(
                      (e: PlayerNotesType) => e.playerId === player.id
                    )?.type
                  : "F",
              sort: player.jerseyNumber,
            },
            style: { width: "60px" },
            print: (content) => (
              <>
                <label
                  style={{
                    background: playerNotesColors.find(
                      (e) => e.playerId === player.id
                    )?.color
                      ? playerNotesColors.find((e) => e.playerId === player.id)
                          ?.color
                      : "green",
                    color: content.type === "M" ? "black" : "white",
                    width: "15px",
                    borderRadius: "25px",
                    textAlign: "center",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                >
                  {content.type}
                </label>
                <button
                  style={{
                    border: "none",
                    background: "none",
                    padding: "0",
                    position: "relative",
                  }}
                  onClick={() => {
                    setPlayerId(player.id);
                    setShowPlayerNote(true);
                    setPlayerTeamId(player.teamId);
                    setPlayerName(player.name);
                    setPlayerNote(
                      playerNotes.find(
                        (e: PlayerNotesType) => e.playerId === player.id
                      )?.note
                    );
                    setNoteType(
                      playerNotes.find(
                        (e: PlayerNotesType) => e.playerId === player.id
                      )?.type
                    );
                  }}
                >
                  <TextBoxIcon
                    width={"17px"}
                    fill={
                      playerNotes &&
                      playerNotes.find(
                        (e: PlayerNotesType) => e.playerId === player.id
                      ) &&
                      playerNotes.find(
                        (e: PlayerNotesType) => e.playerId === player.id
                      )?.note
                        ? "#007ABA"
                        : ""
                    }
                  />
                </button>
              </>
            ),
            order: (contentA, contentB) => {
              if (contentA.type !== contentB.type) {
                return contentA.type.localeCompare(contentB.type);
              }
              return contentB.sort - contentA.sort;
            },
          },
          {
            content: player.jerseyNumber,
            print: (content) => (
              <Link to={{ pathname: prePath + "/modal/" + player.id }}>
                {"#" + content}
              </Link>
            ),
            order: (contentA: string, contentB: string) => {
              const jerseyA = contentA.replace(/\D/g, "");
              const jerseyB = contentB.replace(/\D/g, "");
              const jerseyLetterA = contentA.replace(jerseyA, "");
              const jerseyLetterB = contentB.replace(jerseyB, "");
              if (+jerseyA !== +jerseyB) {
                return +jerseyB - +jerseyA;
              }
              return jerseyLetterB.localeCompare(jerseyLetterA);
            },
          },
          {
            class: "t-ll",
            content: player.position,
            print: (content) => (
              <Link to={{ pathname: prePath + "/modal/" + player.id }}>
                {content}
              </Link>
            ),
          },
          ...(viewData.value === VIEW_LIVE.types[0].value
            ? [
                {
                  class: "ll-pp",
                  content: fixDecimals(
                    player.metrics[
                      customZone
                        ? CUSTOM_ZONE_METRICS["targetMPH"]
                        : relative
                        ? RELATIVE_METRICS["targetMPH"]
                        : "targetMPH"
                    ],
                    1
                  ),
                  print: (content: number) => <div>{content}</div>,
                },
                {
                  class: "ll-pp",
                  content: {
                    maxSpeed: customZone
                      ? fixDecimals(
                          player.metrics[CUSTOM_ZONE_METRICS["maxSpeedMPH"]],
                          2
                        )
                      : fixDecimals(player.metrics.maxSpeedMPH, 2),
                    maxSpeedAs: Number.isInteger(
                      +fixDecimals(
                        (customZone
                          ? player.metrics["maxSpeedMPHAs%ofTarget_Custom"]
                          : relative
                          ? player.metrics["maxSpeedMPHAs%ofTarget_Relative"]
                          : player.metrics["maxSpeedMPHAs%ofTarget"]) * 100,
                        0
                      )
                    )
                      ? `(${fixDecimals(
                          (customZone
                            ? player.metrics["maxSpeedMPHAs%ofTarget_Custom"]
                            : relative
                            ? player.metrics["maxSpeedMPHAs%ofTarget_Relative"]
                            : player.metrics["maxSpeedMPHAs%ofTarget"]) * 100,
                          0
                        )}%)`
                      : "-",
                    maxSpeedPerc: +fixDecimals(
                      (customZone
                        ? player.metrics["maxSpeedMPHAs%ofTarget_Custom"]
                        : relative
                        ? player.metrics["maxSpeedMPHAs%ofTarget_Relative"]
                        : player.metrics["maxSpeedMPHAs%ofTarget"]) * 100,
                      0
                    ),
                  },
                  print: (content: {
                    maxSpeed: string;
                    maxSpeedAs: string;
                  }) => (
                    <div style={{ width: "65px", maxWidth: "65px" }}>
                      {content.maxSpeed + " "}
                      <label>{content.maxSpeedAs}</label>
                    </div>
                  ),
                  order: (
                    contentA: { maxSpeed: number; maxSpeedPerc: number },
                    contentB: { maxSpeed: number; maxSpeedPerc: number }
                  ) =>
                    !sortByPercentageSpeed
                      ? contentA.maxSpeed - contentB.maxSpeed
                      : contentA.maxSpeedPerc - contentB.maxSpeedPerc,
                },
                {
                  class: "ll-pp",
                  content: {
                    maxSustainedSpeed: customZone
                      ? fixDecimals(
                          player.metrics[
                            CUSTOM_ZONE_METRICS["maxSustainedSpeedMPH"]
                          ],
                          2
                        )
                      : fixDecimals(player.metrics.maxSustainedSpeedMPH, 2),
                    maxSustSpeedPerc: +fixDecimals(
                      (customZone
                        ? player.metrics["maxSustSpeedMPHAs%ofTarget_Custom"]
                        : relative
                        ? player.metrics["maxSustSpeedMPHAs%ofTarget_Relative"]
                        : player.metrics["maxSustSpeedMPHAs%ofTarget"]) * 100,
                      0
                    ),
                  },
                  print: (content: { maxSustainedSpeed: string }) => (
                    <div style={{ width: "65px", maxWidth: "65px" }}>
                      {content.maxSustainedSpeed + " "}
                      <label>
                        {Number.isInteger(
                          +fixDecimals(
                            (customZone
                              ? player.metrics[
                                  "maxSustSpeedMPHAs%ofTarget_Custom"
                                ]
                              : relative
                              ? player.metrics[
                                  "maxSustSpeedMPHAs%ofTarget_Relative"
                                ]
                              : player.metrics["maxSustSpeedMPHAs%ofTarget"]) *
                              100,
                            0
                          )
                        )
                          ? `(${fixDecimals(
                              (customZone
                                ? player.metrics[
                                    "maxSustSpeedMPHAs%ofTarget_Custom"
                                  ]
                                : relative
                                ? player.metrics[
                                    "maxSustSpeedMPHAs%ofTarget_Relative"
                                  ]
                                : player.metrics[
                                    "maxSustSpeedMPHAs%ofTarget"
                                  ]) * 100,
                              0
                            )}%)`
                          : "-"}
                      </label>
                    </div>
                  ),
                  order: (
                    contentA: {
                      maxSustainedSpeed: number;
                      maxSustSpeedPerc: number;
                    },
                    contentB: {
                      maxSustainedSpeed: number;
                      maxSustSpeedPerc: number;
                    }
                  ) =>
                    !sortByPercentageSpeed
                      ? contentA.maxSustainedSpeed - contentB.maxSustainedSpeed
                      : contentA.maxSustSpeedPerc - contentB.maxSustSpeedPerc,
                },
                {
                  class: "ll-pp t-ll",
                  content: msToTime(
                    player.metrics[
                      customZone
                        ? CUSTOM_ZONE_METRICS["lastTimeVelocityTargetHitTs"]
                        : relative
                        ? RELATIVE_METRICS["lastTimeVelocityTargetHitTs"]
                        : "lastTimeVelocityTargetHitTs"
                    ] || 0
                  ),
                },
                {
                  class: "ll-pp",
                  content: {
                    totalDis: player.metrics.totalDis,
                    totalDisPercentage:
                      isLive && dateRange && dateRange.isUseInProgressComps
                        ? player.metrics["historyDistMovedAtSec_%"]
                        : player.metrics["historyTotalDistance_%"],
                  },
                  print: (content: {
                    totalDis: number;
                    totalDisPercentage: number;
                  }) => (
                    <div>
                      {fixDecimals(content.totalDis, 0) + " "}
                      {(periods?.length === 0 || isLive) && (
                        <label
                          className={"percentage"}
                          style={
                            thresholdSelected != "Select" &&
                            isLive &&
                            +fixDecimals(
                              player.metrics["historyTotalDistance_%"] * 100,
                              0
                            ) >= thresholdSelected
                              ? { color: "red" }
                              : { color: "" }
                          }
                        >
                          {Number.isInteger(
                            +fixDecimals(content.totalDisPercentage * 100, 0)
                          ) &&
                          +fixDecimals(content.totalDisPercentage * 100, 0) >= 0
                            ? `(${fixDecimals(
                                content.totalDisPercentage * 100,
                                0
                              )}%)`
                            : "-"}
                        </label>
                      )}
                    </div>
                  ),
                  order: (
                    contentA: { totalDis: number; totalDisPercentage: number },
                    contentB: { totalDis: number; totalDisPercentage: number }
                  ) =>
                    !sortByPercentageDist
                      ? contentA.totalDis - contentB.totalDis
                      : contentA.totalDisPercentage -
                        contentB.totalDisPercentage,
                  style: { padding: "19px 5px" },
                },
                {
                  class: "ll-pp",
                  content: {
                    hardDist:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["hardEffortDist"]
                          : relative
                          ? RELATIVE_METRICS["hardEffortDist"]
                          : "hardEffortDist"
                      ],
                    hardDistPercentage:
                      isLive && dateRange && dateRange.isUseInProgressComps
                        ? player.metrics["historyTeamHEDMovedAtSec_%"]
                        : player.metrics[
                            customZone
                              ? CUSTOM_ZONE_METRICS[
                                  "historyHardEffortDistance_%"
                                ]
                              : relative
                              ? RELATIVE_METRICS["historyHardEffortDistance_%"]
                              : "historyHardEffortDistance_%"
                          ],
                  },
                  print: (content: {
                    hardDist: number;
                    hardDistPercentage: number;
                  }) => (
                    <div>
                      {" "}
                      {fixDecimals(content.hardDist, 0) + " "}
                      {(periods?.length === 0 || isLive) && (
                        <label
                          className="percentage"
                          style={
                            thresholdSelected != "Select" &&
                            isLive &&
                            (relative === 0
                              ? +fixDecimals(
                                  player.metrics[
                                    "historyHardEffortDistance_%"
                                  ] * 100,
                                  0
                                )
                              : +fixDecimals(
                                  player.metrics[
                                    "historyHardEffortDistanceRelative_%"
                                  ] * 100,
                                  0
                                )) >= thresholdSelected
                              ? { color: "red" }
                              : { color: "" }
                          }
                        >
                          {Number.isInteger(
                            +fixDecimals(content.hardDistPercentage * 100, 0)
                          ) &&
                          +fixDecimals(content.hardDistPercentage * 100, 0) >= 0
                            ? `(${fixDecimals(
                                content.hardDistPercentage * 100,
                                0
                              )}%)`
                            : "-"}
                        </label>
                      )}
                    </div>
                  ),
                  order: (
                    contentA: { hardDist: number; hardDistPercentage: number },
                    contentB: { hardDist: number; hardDistPercentage: number }
                  ) =>
                    !sortByPercentageDist
                      ? contentA.hardDist - contentB.hardDist
                      : contentA.hardDistPercentage -
                        contentB.hardDistPercentage,
                  style: { padding: "19px 5px" },
                },
                {
                  class: "ll-pp",
                  content: {
                    walkYds:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["walkYds"]
                          : relative
                          ? RELATIVE_METRICS["walkYds"]
                          : "walkYds"
                      ],
                    walkYdsPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["walkYds_%"]
                          : relative
                          ? RELATIVE_METRICS["walkYds_%"]
                          : "walkYds_%"
                      ],
                    walkCount:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["walkCount"]
                          : relative
                          ? RELATIVE_METRICS["walkCount"]
                          : "walkCount"
                      ],
                    walkCountPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["walkCount_%"]
                          : relative
                          ? RELATIVE_METRICS["walkCount_%"]
                          : "walkCount_%"
                      ],
                  },
                  print: (content: {
                    walkYds: number;
                    walkCount: number;
                    walkCountPercentage: number;
                    walkYdsPercentage: number;
                  }) => (
                    <div>
                      {!isCounts
                        ? fixDecimals(content.walkYds, 0)
                        : fixDecimals(content.walkCount, 0) + " "}
                      {(periods?.length === 0 || isLive) && (
                        <label
                          className="percentage"
                          style={
                            thresholdSelected != "Select" &&
                            isLive &&
                            (relative === 0
                              ? isCounts
                                ? +fixDecimals(
                                    player.metrics["walkCount_%"] * 100,
                                    0
                                  )
                                : +fixDecimals(
                                    player.metrics["walkYds_%"] * 100,
                                    0
                                  )
                              : isCounts
                              ? +fixDecimals(
                                  player.metrics["walkCountRelative_%"] * 100,
                                  0
                                )
                              : +fixDecimals(
                                  player.metrics["walkYdsRelative_%"] * 100,
                                  0
                                )) >= thresholdSelected
                              ? { color: "red" }
                              : { color: "" }
                          }
                        >
                          {isCounts
                            ? Number.isInteger(
                                +fixDecimals(
                                  content.walkCountPercentage * 100,
                                  0
                                )
                              ) &&
                              +fixDecimals(
                                content.walkCountPercentage * 100,
                                0
                              ) >= 0
                              ? `(${fixDecimals(
                                  content.walkCountPercentage * 100,
                                  0
                                )}%)`
                              : "-"
                            : Number.isInteger(
                                +fixDecimals(content.walkYdsPercentage * 100, 0)
                              ) &&
                              +fixDecimals(
                                content.walkYdsPercentage * 100,
                                0
                              ) >= 0
                            ? `(${fixDecimals(
                                content.walkYdsPercentage * 100,
                                0
                              )}%)`
                            : "-"}
                        </label>
                      )}
                    </div>
                  ),
                  order: (
                    contentA: {
                      walkYds: number;
                      walkCount: number;
                      walkCountPercentage: number;
                      walkYdsPercentage: number;
                    },
                    contentB: {
                      walkYds: number;
                      walkCount: number;
                      walkCountPercentage: number;
                      walkYdsPercentage: number;
                    }
                  ) =>
                    !isCounts
                      ? !sortByPercentageDist
                        ? contentA.walkYds - contentB.walkYds
                        : contentA.walkYdsPercentage -
                          contentB.walkYdsPercentage
                      : !sortByPercentageDist
                      ? contentA.walkCount - contentB.walkCount
                      : contentA.walkCountPercentage -
                        contentB.walkCountPercentage,
                  style: { padding: "19px 5px" },
                },
                {
                  class: "ll-pp",
                  content: {
                    jogYds:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["jogYds"]
                          : relative
                          ? RELATIVE_METRICS["jogYds"]
                          : "jogYds"
                      ],
                    jogYdsPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["jogYds_%"]
                          : relative
                          ? RELATIVE_METRICS["jogYds_%"]
                          : "jogYds_%"
                      ],
                    jogCount:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["jogCount"]
                          : relative
                          ? RELATIVE_METRICS["jogCount"]
                          : "jogCount"
                      ],
                    jogCountPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["jogCount_%"]
                          : relative
                          ? RELATIVE_METRICS["jogCount_%"]
                          : "jogCount_%"
                      ],
                  },
                  print: (content: {
                    jogYds: number;
                    jogCount: number;
                    jogCountPercentage: number;
                    jogYdsPercentage: number;
                  }) => (
                    <div>
                      {!isCounts
                        ? fixDecimals(content.jogYds, 0)
                        : fixDecimals(content.jogCount, 0) + " "}
                      {(periods?.length === 0 || isLive) && (
                        <label
                          className="percentage"
                          style={
                            thresholdSelected != "Select" &&
                            isLive &&
                            (relative === 0
                              ? isCounts
                                ? +fixDecimals(
                                    player.metrics["jogCount_%"] * 100,
                                    0
                                  )
                                : +fixDecimals(
                                    player.metrics["jogYds_%"] * 100,
                                    0
                                  )
                              : isCounts
                              ? +fixDecimals(
                                  player.metrics["jogCountRelative_%"] * 100,
                                  0
                                )
                              : +fixDecimals(
                                  player.metrics["jogYdsRelative_%"] * 100,
                                  0
                                )) >= thresholdSelected
                              ? { color: "red" }
                              : { color: "" }
                          }
                        >
                          {isCounts
                            ? Number.isInteger(
                                +fixDecimals(
                                  content.jogCountPercentage * 100,
                                  0
                                )
                              ) &&
                              +fixDecimals(
                                content.jogCountPercentage * 100,
                                0
                              ) >= 0
                              ? `(${fixDecimals(
                                  content.jogCountPercentage * 100,
                                  0
                                )}%)`
                              : "-"
                            : Number.isInteger(
                                +fixDecimals(content.jogYdsPercentage * 100, 0)
                              ) &&
                              +fixDecimals(content.jogYdsPercentage * 100, 0) >=
                                0
                            ? `(${fixDecimals(
                                content.jogYdsPercentage * 100,
                                0
                              )}%)`
                            : "-"}
                        </label>
                      )}
                    </div>
                  ),
                  order: (
                    contentA: {
                      jogYds: number;
                      jogCount: number;
                      jogCountPercentage: number;
                      jogYdsPercentage: number;
                    },
                    contentB: {
                      jogYds: number;
                      jogCount: number;
                      jogCountPercentage: number;
                      jogYdsPercentage: number;
                    }
                  ) =>
                    !isCounts
                      ? !sortByPercentageDist
                        ? contentA.jogYds - contentB.jogYds
                        : contentA.jogYdsPercentage - contentB.jogYdsPercentage
                      : !sortByPercentageDist
                      ? contentA.jogCount - contentB.jogCount
                      : contentA.jogCountPercentage -
                        contentB.jogCountPercentage,
                  style: { padding: "19px 5px" },
                },
                {
                  class: "ll-pp",
                  content: {
                    runYds:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["runYds"]
                          : relative
                          ? RELATIVE_METRICS["runYds"]
                          : "runYds"
                      ],
                    runYdsPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["runYds_%"]
                          : relative
                          ? RELATIVE_METRICS["runYds_%"]
                          : "runYds_%"
                      ],
                    runCount:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["runCount"]
                          : relative
                          ? RELATIVE_METRICS["runCount"]
                          : "runCount"
                      ],
                    runCountPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["runCount_%"]
                          : relative
                          ? RELATIVE_METRICS["runCount_%"]
                          : "runCount_%"
                      ],
                  },
                  print: (content: {
                    runYds: number;
                    runCount: number;
                    runCountPercentage: number;
                    runYdsPercentage: number;
                  }) => (
                    <div>
                      {!isCounts
                        ? fixDecimals(content.runYds, 0)
                        : fixDecimals(content.runCount, 0) + " "}
                      {(periods?.length === 0 || isLive) && (
                        <label
                          className="percentage"
                          style={
                            thresholdSelected != "Select" &&
                            isLive &&
                            (relative === 0
                              ? isCounts
                                ? +fixDecimals(
                                    player.metrics["runCount_%"] * 100,
                                    0
                                  )
                                : +fixDecimals(
                                    player.metrics["runYds_%"] * 100,
                                    0
                                  )
                              : isCounts
                              ? +fixDecimals(
                                  player.metrics["runCountRelative_%"] * 100,
                                  0
                                )
                              : +fixDecimals(
                                  player.metrics["runYdsRelative_%"] * 100,
                                  0
                                )) >= thresholdSelected
                              ? { color: "red" }
                              : { color: "" }
                          }
                        >
                          {isCounts
                            ? Number.isInteger(
                                +fixDecimals(
                                  content.runCountPercentage * 100,
                                  0
                                )
                              ) &&
                              +fixDecimals(
                                content.runCountPercentage * 100,
                                0
                              ) >= 0
                              ? `(${fixDecimals(
                                  content.runCountPercentage * 100,
                                  0
                                )}%)`
                              : "-"
                            : Number.isInteger(
                                +fixDecimals(content.runYdsPercentage * 100, 0)
                              ) &&
                              +fixDecimals(content.runYdsPercentage * 100, 0) >=
                                0
                            ? `(${fixDecimals(
                                content.runYdsPercentage * 100,
                                0
                              )}%)`
                            : "-"}
                        </label>
                      )}
                    </div>
                  ),
                  order: (
                    contentA: {
                      runYds: number;
                      runCount: number;
                      runCountPercentage: number;
                      runYdsPercentage: number;
                    },
                    contentB: {
                      runYds: number;
                      runCount: number;
                      runCountPercentage: number;
                      runYdsPercentage: number;
                    }
                  ) =>
                    !isCounts
                      ? !sortByPercentageDist
                        ? contentA.runYds - contentB.runYds
                        : contentA.runYdsPercentage - contentB.runYdsPercentage
                      : !sortByPercentageDist
                      ? contentA.runCount - contentB.runCount
                      : contentA.runCountPercentage -
                        contentB.runCountPercentage,
                  style: { padding: "19px 5px" },
                },
                {
                  class: "ll-pp",
                  content: {
                    sprintYds:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["sprintYds"]
                          : relative
                          ? RELATIVE_METRICS["sprintYds"]
                          : "sprintYds"
                      ],
                    sprintYdsPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["sprintYds_%"]
                          : relative
                          ? RELATIVE_METRICS["sprintYds_%"]
                          : "sprintYds_%"
                      ],
                    sprintCount:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["sprintCount"]
                          : relative
                          ? RELATIVE_METRICS["sprintCount"]
                          : "sprintCount"
                      ],
                    sprintCountPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["sprintCount_%"]
                          : relative
                          ? RELATIVE_METRICS["sprintCount_%"]
                          : "sprintCount_%"
                      ],
                  },
                  print: (content: {
                    sprintYds: number;
                    sprintCount: number;
                    sprintCountPercentage: number;
                    sprintYdsPercentage: number;
                  }) => (
                    <div>
                      {!isCounts
                        ? fixDecimals(content.sprintYds, 0)
                        : fixDecimals(content.sprintCount, 0) + " "}
                      {(periods?.length === 0 || isLive) && (
                        <label
                          className="percentage"
                          style={
                            thresholdSelected != "Select" &&
                            isLive &&
                            (relative === 0
                              ? isCounts
                                ? +fixDecimals(
                                    player.metrics["sprintCount_%"] * 100,
                                    0
                                  )
                                : +fixDecimals(
                                    player.metrics["sprintYds_%"] * 100,
                                    0
                                  )
                              : isCounts
                              ? +fixDecimals(
                                  player.metrics["sprintCountRelative_%"] * 100,
                                  0
                                )
                              : +fixDecimals(
                                  player.metrics["sprintYdsRelative_%"] * 100,
                                  0
                                )) >= thresholdSelected
                              ? { color: "red" }
                              : { color: "" }
                          }
                        >
                          {isCounts
                            ? Number.isInteger(
                                +fixDecimals(
                                  content.sprintCountPercentage * 100,
                                  0
                                )
                              ) &&
                              +fixDecimals(
                                content.sprintCountPercentage * 100,
                                0
                              ) >= 0
                              ? `(${fixDecimals(
                                  content.sprintCountPercentage * 100,
                                  0
                                )}%)`
                              : "-"
                            : Number.isInteger(
                                +fixDecimals(
                                  content.sprintYdsPercentage * 100,
                                  0
                                )
                              ) &&
                              +fixDecimals(
                                content.sprintYdsPercentage * 100,
                                0
                              ) >= 0
                            ? `(${fixDecimals(
                                content.sprintYdsPercentage * 100,
                                0
                              )}%)`
                            : "-"}
                        </label>
                      )}
                    </div>
                  ),
                  order: (
                    contentA: {
                      sprintYds: number;
                      sprintCount: number;
                      sprintYdsPercentage: number;
                      sprintCountPercentage: number;
                    },
                    contentB: {
                      sprintYds: number;
                      sprintCount: number;
                      sprintYdsPercentage: number;
                      sprintCountPercentage: number;
                    }
                  ) =>
                    !isCounts
                      ? !sortByPercentageDist
                        ? contentA.sprintYds - contentB.sprintYds
                        : contentA.sprintYdsPercentage -
                          contentB.sprintYdsPercentage
                      : !sortByPercentageDist
                      ? contentA.sprintCount - contentB.sprintCount
                      : contentA.sprintCountPercentage -
                        contentB.sprintCountPercentage,
                  style: { padding: "19px 5px" },
                },
                {
                  class: "t-ll",
                  content: {
                    maxSprintYds:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["maxSprintYds"]
                          : relative
                          ? RELATIVE_METRICS["maxSprintYds"]
                          : "maxSprintYds"
                      ],
                    maxSprintYdsPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["maxSprintYds_%"]
                          : relative
                          ? RELATIVE_METRICS["maxSprintYds_%"]
                          : "maxSprintYds_%"
                      ],
                    maxSprintCount:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["maxSprintCount"]
                          : relative
                          ? RELATIVE_METRICS["maxSprintCount"]
                          : "maxSprintCount"
                      ],
                    maxSprintCountPercentage:
                      player.metrics[
                        customZone
                          ? CUSTOM_ZONE_METRICS["maxSprintCount_%"]
                          : relative
                          ? RELATIVE_METRICS["maxSprintCount_%"]
                          : "maxSprintCount_%"
                      ],
                  },
                  print: (content: {
                    maxSprintYds: number;
                    maxSprintCount: number;
                    maxSprintCountPercentage: number;
                    maxSprintYdsPercentage: number;
                  }) => (
                    <div>
                      {!isCounts
                        ? fixDecimals(content.maxSprintYds, 0)
                        : fixDecimals(content.maxSprintCount, 0) + " "}
                      {(periods?.length === 0 || isLive) && (
                        <label
                          className="percentage"
                          style={
                            thresholdSelected != "Select" &&
                            isLive &&
                            (relative === 0
                              ? isCounts
                                ? +fixDecimals(
                                    player.metrics["maxSprintCount_%"] * 100,
                                    0
                                  )
                                : +fixDecimals(
                                    player.metrics["maxSprintYds_%"] * 100,
                                    0
                                  )
                              : isCounts
                              ? +fixDecimals(
                                  player.metrics["maxSprintCountRelative_%"] *
                                    100,
                                  0
                                )
                              : +fixDecimals(
                                  player.metrics["maxSprintYdsRelative_%"] *
                                    100,
                                  0
                                )) >= thresholdSelected
                              ? { color: "red" }
                              : { color: "" }
                          }
                        >
                          {isCounts
                            ? Number.isInteger(
                                +fixDecimals(
                                  content.maxSprintCountPercentage * 100,
                                  0
                                )
                              ) &&
                              +fixDecimals(
                                content.maxSprintCountPercentage * 100,
                                0
                              ) >= 0
                              ? `(${fixDecimals(
                                  content.maxSprintCountPercentage * 100,
                                  0
                                )}%)`
                              : "-"
                            : Number.isInteger(
                                +fixDecimals(
                                  content.maxSprintYdsPercentage * 100,
                                  0
                                )
                              ) &&
                              +fixDecimals(
                                content.maxSprintYdsPercentage * 100,
                                0
                              ) >= 0
                            ? `(${fixDecimals(
                                content.maxSprintYdsPercentage * 100,
                                0
                              )}%)`
                            : "-"}
                        </label>
                      )}
                    </div>
                  ),
                  order: (
                    contentA: {
                      maxSprintYds: number;
                      maxSprintCount: number;
                      maxSprintYdsPercentage: number;
                      maxSprintCountPercentage: number;
                    },
                    contentB: {
                      maxSprintYds: number;
                      maxSprintCount: number;
                      maxSprintYdsPercentage: number;
                      maxSprintCountPercentage: number;
                    }
                  ) =>
                    !isCounts
                      ? !sortByPercentageDist
                        ? contentA.maxSprintYds - contentB.maxSprintYds
                        : contentA.maxSprintYdsPercentage -
                          contentB.maxSprintYdsPercentage
                      : !sortByPercentageDist
                      ? contentA.maxSprintCount - contentB.maxSprintCount
                      : contentA.maxSprintCountPercentage -
                        contentB.maxSprintCountPercentage,
                  style: { padding: "19px 5px" },
                },
                { content: fixDecimals(player.metrics.accelSlow, 0) },
                { content: fixDecimals(player.metrics.accelMed, 0) },
                { content: fixDecimals(player.metrics.accelFast, 0) },
                {
                  content: fixDecimals(player.metrics.maxSustAccel, 2),
                  class: "t-ll",
                },
                { content: fixDecimals(player.metrics.deccelSlow, 0) },
                { content: fixDecimals(player.metrics.deccelMed, 0) },
                { content: fixDecimals(player.metrics.deccelFast, 0) },
                {
                  content: fixDecimals(player.metrics.maxSustDecel, 2),
                  class: "t-ll",
                },
                {
                  content: fixDecimals(player.metrics.cumulativeBalanceLoad, 2),
                },
                {
                  content: fixDecimals(player.metrics.biasedBalanceLoad, 2),
                  class: "t-ll",
                },
              ]
            : viewData.value === VIEW_LIVE.types[1].value
            ? [
                ...CUSTOM_ROWS.map((key, index) => {
                  return {
                    style:
                      CUSTOM_ROWS.length <= 11
                        ? index + 1 === CUSTOM_ROWS.length
                          ? {
                              width: `${
                                customTotalWidth - (CUSTOM_ROWS.length - 1) * 85
                              }px`,
                            }
                          : { width: "85px" }
                        : {},
                    content: {
                      content:
                        key === " "
                          ? ""
                          : key.includes("Time")
                          ? msToTime(player.metrics[key] || 0)
                          : key.includes("targetMPH")
                          ? fixDecimals(player.metrics[key], 1)
                          : key.includes("Speed")
                          ? key === "maxSpeedMPHRelative"
                            ? fixDecimals(player.metrics["maxSpeedMPH"], 2)
                            : fixDecimals(player.metrics[key], 2)
                          : key.includes("Load")
                          ? fixDecimals(player.metrics[key], 2)
                          : key.includes("maxSustAccel") ||
                            key.includes("maxSustDecel")
                          ? fixDecimals(player.metrics[key], 2)
                          : fixDecimals(player.metrics[key], 0),
                      percentage:
                        CUSTOM_ROWS_PERCENTAGES[index] &&
                        CUSTOM_ROWS_PERCENTAGES[index] !== ""
                          ? player.metrics[CUSTOM_ROWS_PERCENTAGES[index]]
                          : "",
                      order:
                        key === "lastTimeVelocityTargetHitTs" ||
                        key === "lastTimeVelocityTargetHitTsRelative"
                          ? player.metrics[key]
                          : "",
                    },
                    print: (content: {
                      content: number;
                      percentage: number;
                    }) => (
                      <div>
                        {content.content + ` `}
                        {content.percentage ? (
                          !key.includes("MPH") ? (
                            <label
                              className="percentage"
                              style={
                                thresholdSelected != "Select" &&
                                isLive &&
                                +fixDecimals(content.percentage * 100, 0) >=
                                  thresholdSelected
                                  ? { color: "red" }
                                  : { color: "" }
                              }
                            >
                              {Number.isInteger(
                                +fixDecimals(content.percentage * 100, 0)
                              ) &&
                              +fixDecimals(content.percentage * 100, 0) >= 0
                                ? `(${fixDecimals(
                                    content.percentage * 100,
                                    0
                                  )}%)`
                                : "-"}
                            </label>
                          ) : (
                            <label>
                              {Number.isInteger(
                                +fixDecimals(content.percentage * 100, 0)
                              )
                                ? `(${fixDecimals(
                                    content.percentage * 100,
                                    0
                                  )}%)`
                                : "-"}
                            </label>
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    ),
                    order: (
                      contentA: { content: number; order: number, percentage: number },
                      contentB: { content: number; order: number, percentage: number }
                    ) =>
                      key === "lastTimeVelocityTargetHitTs" ||
                      key === "lastTimeVelocityTargetHitTsRelative"
                        ? sortByPercentageCustom? contentA.percentage - contentB.percentage : contentA.order - contentB.order
                        : sortByPercentageCustom? contentA.percentage - contentB.percentage : contentA.content - contentB.content,
                  };
                }),
              ]
            : []),
        ],
        childrenBelow: showDistanceGraphs && (
          <DistanceGraphOnRow
            totalDis={player.metrics.totalDis}
            maxDistance={maxDistance}
            showDistanceGraphs={showDistanceGraphs}
            dataDistanceGraph={dataDistanceGraph as number[]}
          />
        ),
        id: player.id,
      });
    });
  }
  const titleHeaders = [
    {
      class: "t-ll",
      style: { width: "376px" },
      isColumnFixedY: true,
      content: <div>Player</div>,
    },
    {
      class: "t-ll",
      style: { width: "300px" },
      content: (
        <>
          <div>Speed</div>
          <div
            onClick={() => changeSortValue(true, false, false)}
            style={{ fontSize: "15px", fontWeight: "bold" }}
          >
            {!sortByPercentageSpeed ? (
              <>
                <i className="mdi mdi-pound" style={{ color: "#333d47" }} />/
                <i className="mdi mdi-percent" style={{ color: "#C8C7C7" }} />
              </>
            ) : (
              <>
                <i className="mdi mdi-pound" style={{ color: "#C8C7C7" }} />/
                <i className="mdi mdi-percent" style={{ color: "#333d47" }} />
              </>
            )}
          </div>
        </>
      ),
    },
    {
      class: "t-ll",
      style: { width: "517px" },
      content: (
        <>
          <div onClick={() => changeHeadersCount()}>
            {!isCounts ? (
              <>
                <b style={{ color: "#333d47" }}>Distances</b>/
                <b style={{ color: "#C8C7C7" }}>Counts</b>
              </>
            ) : (
              <>
                <b style={{ color: "#C8C7C7" }}>Distances</b>/
                <b style={{ color: "#333d47" }}>Counts</b>
              </>
            )}
          </div>
          <div
            onClick={() => changeSortValue(false, true, false)}
            style={{ fontSize: "15px", fontWeight: "bold" }}
          >
            {!sortByPercentageDist ? (
              <>
                <i className="mdi mdi-pound" style={{ color: "#333d47" }} />/
                <i className="mdi mdi-percent" style={{ color: "#C8C7C7" }} />
              </>
            ) : (
              <>
                <i className="mdi mdi-pound" style={{ color: "#C8C7C7" }} />/
                <i className="mdi mdi-percent" style={{ color: "#333d47" }} />
              </>
            )}
          </div>
        </>
      ),
    },
    {
      class: "t-ll",
      style: { width: "200px" },
      content: <div>Accels</div>,
    },
    { style: { width: "200px" }, class: "t-ll", content: <div>Decels</div> },
    {
      style: { width: "133px" },
      class: "t-ll",
      content: <div>Load Metrics</div>,
    },
  ];
  const headerCustom = [
    {
      class: "t-ll",
      style: { width: "376px" },
      isColumnFixedY: true,
      content: <div>Player</div>,
    },
    {
      class: "t-ll",
      style: { width: "896px" },
      isCustomHeader: true,
      isColumnFixedY: true,
      content: (<>
        <div>Custom View</div>
          <div
            onClick={() => changeSortValue(false,false, true)}
            style={{ fontSize: "15px", fontWeight: "bold" }}
          >
            {!sortByPercentageCustom ? (
              <>
                <i className="mdi mdi-pound" style={{ color: "#333d47" }} />/
                <i className="mdi mdi-percent" style={{ color: "#C8C7C7" }} />
              </>
            ) : (
              <>
                <i className="mdi mdi-pound" style={{ color: "#C8C7C7" }} />/
                <i className="mdi mdi-percent" style={{ color: "#333d47" }} />
              </>
            )}
          </div>
      </>),
    },
  ];

  const specificExpandedScope = (specificScope || "")
    .split("CONDENSED")
    .join("EXPANDED");

  return (
    <>
      {params.modal && params.playerId && (
        <PlayerBallMetricsModal
          initialTab={"performance-01"}
          show
          onHide={() => history.push(prePath + "/page")}
          hidden={hidden}
          hasUpdate={hasUpdate}
        />
      )}
      {playerId && gameId && (
        <PlayerNoteModal
          show={showPlayerNote}
          close={() => setShowPlayerNote(false)}
          playerId={playerId}
          gameId={gameId}
          teamId={playerTeamId}
          playerName={playerName}
          playerNote={playerNote}
          playerNoteType={noteType}
        />
      )}
      {updateSpeeds && (
        <LiveSpeedsModal
          show={!!showUpdateSpeeds}
          selectedPlayers={selectedPlayers ? selectedPlayers : []}
          close={() => setShowUpdateSpeeds && setShowUpdateSpeeds(false)}
          setSelectedPlayers={setSelectedPlayers}
          gameId={gameId}
          teamId={teamId}
          setUpdateSpeeds={setUpdateSpeeds}
        />
      )}

      <div
        className={`practice-body mobile-table height-mobile ${
          shownHighlights
            ? "adjust-height-practices-live-metrics-table-open"
            : "adjust-height-practices-live-metrics-table-close"
        }`}
        style={{
          height: shownHighlights
            ? "calc(100vh - 240px)"
            : "calc(100vh - 202px)",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <Table<HeadsType, RowType>
          classTable="condensed-view"
          forceScope={
            viewData.value === VIEW_LIVE.types[1].value && !customZone
              ? "CUSTOM_LIVE_TABLE"
              : "CONDENSED_VIEW"
          }
          headers={headers}
          titleHeaders={
            viewData?.value === VIEW_LIVE.types[1].value
              ? headerCustom
              : titleHeaders
          }
          rows={rows}
          default={{
            orderColumn: viewData.value === VIEW_LIVE.types[1].value ? -3 : 11,
          }}
          linkPinnedRows={[specificExpandedScope]}
          isPersistent={
            data.meta.type === LIVE_PRACTICE || data.meta.type === PAST_PRACTICE
          }
          isPinnedStyle
          hasHeadersTooltip
          customRows={
            viewData.value === VIEW_LIVE.types[1].value
              ? viewCustom.length
              : undefined
          }
          isTargeted={targetedReprocess || updateSpeeds}
        />
        {isMobile ? (
          <div className="live-metrics-mobile">
            <CondensedMobile
              rows={data.data.players}
              showHighlights={shownHighlights}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};
